import { exportHtml } from "@api/stores/salesInvoices/exportHtml/api";
import { exportPDF } from "@api/stores/salesInvoices/exportPDF/api";
import { installments } from "@api/stores/salesInvoices/installments/api";
import { items } from "@api/stores/salesInvoices/items/api";
import { payments } from "@api/stores/salesInvoices/payments/api";
import { returns } from "@api/stores/salesInvoices/returns/api";
import { stats } from "@api/stores/salesInvoices/stats/api";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  ISalesInvoicesDto,
  ISalesInvoicesGetAllParams,
  ISalesInvoicesResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISalesInvoicesResponse>>,
  IPathBaseParam,
  IPaginationParams & ISalesInvoicesGetAllParams
>("stores.salesInvoices");
const postApis = createPostApi<
  IApiResponse<ISalesInvoicesResponse>,
  IPathBaseParam,
  ISalesInvoicesDto
>("stores.salesInvoices");
const getApis = createGetApi<
  IApiResponse<ISalesInvoicesResponse>,
  IPathByIdParam,
  object
>("stores.salesInvoices");
const deleteApis = createDeleteApi<
  IApiResponse<ISalesInvoicesResponse>,
  IPathByIdParam
>("stores.salesInvoices");

export const salesInvoices = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...deleteApis,
  stats,
  exportPDF,
  items,
  installments,
  payments,
  returns,
  exportHtml,
};
